import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ThemePalette } from '@angular/material/core';
export type LTSplitButtonOption = {
  label: string;
  icon?: string;
  iconClass?: string;
  disabled?: boolean;
  show?: boolean;
  tooltip?: string;
  click: () => void;
};

@Component({
  selector: 'app-lt-split-button',
  imports: [CommonModule, MatIconModule, MatMenuModule, MatButtonModule, MatTooltipModule],
  template: `
    @if(variant() === 'text') {
      <button mat-button class="split-btn" [disabled]="disabled()" [ngClass]="buttonClass()" [color]="theme()" (click)="handleButtonClick()">
        @if(icon()){
          <mat-icon fontSet="material-icons-outlined" class="icon-prefix" [ngClass]="iconClass()">
            {{ icon() }}
          </mat-icon>
        }
        {{ text() }}
      </button>
      <button mat-button [disabled]="disabled()" class="split-button-arrow" [color]="theme()" [matMenuTriggerFor]="menu">
        <mat-icon area-hidden="false">
          expand_more
        </mat-icon>
      </button>
    }
    @else if(variant() === 'elevated') {
      <button matButton="elevated" class="split-btn" [disabled]="disabled()" [ngClass]="buttonClass()" [color]="theme()" (click)="handleButtonClick()">
        @if(icon()){
          <mat-icon fontSet="material-icons-outlined" class="icon-prefix" [ngClass]="iconClass()">
            {{ icon() }}
          </mat-icon>
        }
        {{ text() }}
      </button>
      <button matButton="elevated" [disabled]="disabled()" class="split-button-arrow" [color]="theme()" [matMenuTriggerFor]="menu">
        <mat-icon area-hidden="false">
          expand_more
        </mat-icon>
      </button>
    }
    @else if(variant() === 'outlined') {
      <button matButton="elevated" class="split-btn" [disabled]="disabled()" [ngClass]="buttonClass()" [color]="theme()" (click)="handleButtonClick()">
        @if(icon()){
          <mat-icon fontSet="material-icons-outlined" class="icon-prefix" [ngClass]="iconClass()">
            {{ icon() }}
          </mat-icon>
        }
        {{ text() }}
      </button>
      <button matButton="elevated" [disabled]="disabled()" class="split-button-arrow" [color]="theme()" [matMenuTriggerFor]="menu">
        <mat-icon area-hidden="false">
          expand_more
        </mat-icon>
      </button>
    }
    @else if(variant() === 'filled') {
      <button matButton="filled" class="split-btn" [disabled]="disabled()" [ngClass]="buttonClass()" [color]="theme()" (click)="handleButtonClick()">
        @if(icon()){
          <mat-icon fontSet="material-icons-outlined" class="icon-prefix" [ngClass]="iconClass()">
            {{ icon() }}
          </mat-icon>
        }
        {{ text() }}
      </button>
      <button matButton="filled" [disabled]="disabled()" class="split-button-arrow" [color]="theme()" [matMenuTriggerFor]="menu">
        <mat-icon area-hidden="false">
          expand_more
        </mat-icon>
      </button>
    }

    <mat-menu #menu="matMenu" xPosition="before" [class]="menuClass()">
        @for(option of options(); track $index) {
            @if(option.show === null || option.show === undefined || option.show === true) {
              <button 
                mat-menu-item 
                [disabled]="option.disabled" 
                (click)="option.click()">
                @if(option.icon){
                  <mat-icon [color]="theme()" fontSet="material-icons-outlined">
                    {{ option.icon }}
                  </mat-icon>
                }
                <span>{{ option.label }}</span>
              </button>
            }
        }
    </mat-menu>
  `,
  styles: `
    :host {
      display: flex;
      flex-flow: row nowrap;
    }
    .split-btn {
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;

      .icon-prefix {
        margin-right: 8px;
      }
    }

    .split-button-arrow {
      width: 30px;
      min-width: 24px !important;
      padding: 0 !important;
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;

      .mat-icon {
        margin: 0 !important;
      }
    }
  `,
})
export class LTSplitButtonComponent {
  readonly theme = input<ThemePalette | undefined>();
  readonly variant = input<'text' | 'elevated' | 'outlined' | 'filled'>('text');
  readonly options = input.required<LTSplitButtonOption[]>();
  readonly buttonClass = input<string>('');
  readonly menuClass = input<string>('');
  readonly iconClass = input<string>('');
  readonly text = input<string>('');
  readonly icon = input<string>('');
  readonly disabled = input<boolean>(false);
  
  buttonClick = output<void>();
  handleButtonClick = () => this.buttonClick.emit();
  

}
